module.exports = __webpack_public_path__ + "post-listing-block-2-hotpads@2x-2D1L4tN.png";